import React from 'react';
import * as msgpub from "msgpub";
import {TextArea, ButtonG, Heading} from '../Common';
import { TextInput, Select, Grid, Box, ResponsiveContext } from 'grommet';
import { anyCallBackFunction, getListStr, searchText } from '../../common/AdminMqtt';
import { HeaderStyleForGrommet, MainStyleForGrommet } from '../../constant/Styles';
import { DisabelesAdminContext } from '../../constant/AdminMqtt';
import { status_mapper } from '../../common/common';

const AREAS: {[key: string]: any[]} = {
    small: [
        { name: "area1", start: [0, 0], end: [0, 0] },
        { name: "area2", start: [0, 1], end: [0, 1] },
    ],
    medium: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ],
    large: [
        { name: 'area1', start: [0, 0], end: [1, 0] },
        { name: 'area2', start: [1, 0], end: [2, 0] },
    ]
};

const ROWS: {[key: string]: any[]} = {
    small: ['auto', 'auto'],
    medium: ['auto'],
    large: ['auto']
};

const COLUMNS: {[key: string]: any[]} = {
    small: ['auto'],
    medium: ['auto', 'auto'],
    large: ['auto', 'auto'],
}

export default function UserComponent(props: {admin?: msgpub.Admin, setLog: any}) {
    const {admin, setLog} = props;
    const [userForAdd, setUserForAdd] = React.useState("");
    const [userForRemove, setUserForRemove] = React.useState("");
    const [userList, setUserList] = React.useState<Array<string>>([]);
    const [searchedUserList, setSearchedUserList] = React.useState<Array<string>>([]);
    const size = React.useContext(ResponsiveContext);
    const areas = AREAS[size];
    const rows = ROWS[size];
    const columns = COLUMNS[size];
    const disables = React.useContext(DisabelesAdminContext);
    const [userListStr, setUserListStr] = React.useState<string>('');


    const get = () => {
        anyCallBackFunction(setUserList,
                            setSearchedUserList,
                            setLog,
                            admin?.setUserInfoCallback.bind(admin),
                            admin?.getUsers.bind(admin),
                            "getUsers"
        );
    };

    const getUserListStr = () => {
        getListStr(setUserListStr, setLog, admin?.setUserInfoCallback.bind(admin), admin?.getUsers.bind(admin), "getUsers");
    }

    const add = () => {
        admin?.addUser({
            user: userForAdd,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[add operation]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    const remove = () => {
        admin?.removeUser({
            user: userForRemove,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[remove operation]status: " + status_mapper(status) + "\n"));
            }
        });
    }

    const onChangeForUserAdd = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserForAdd(event.target.value);
    }

    return (
        <div>
            <Grid
                areas={areas}
                rows={rows}
                columns={columns}
                gap="xsmall"
            >
                <Box gridArea='area1'>
                    <Box {...HeaderStyleForGrommet}>
                        <Heading title="add user"/>
                    </Box>
                    <Box {...MainStyleForGrommet}>
                        <form>
                            <TextInput placeholder="new user" value={userForAdd} onChange={onChangeForUserAdd} disabled={disables.others} />
                            <ButtonG name="add" callback={add} disabled={disables.others} />
                        </form>
                    </Box>
                </Box>
                <Box gridArea='area2'>
                    <Box {...HeaderStyleForGrommet}>
                        <Heading title="delete user"/>
                    </Box>
                    <Box {...MainStyleForGrommet}>
                        <form>
                            <Select
                                placeholder="select user"
                                value={userForRemove}
                                onSearch={input => {searchText(input, userList, setSearchedUserList)}}
                                onChange={(event) => {
                                    setUserForRemove(event.value);
                                }}
                                onOpen={get}
                                options={searchedUserList}
                                disabled={disables.others}
                            />
                            <ButtonG name="delete" callback={remove} disabled={disables.others} />
                        </form>
                    </Box>
                </Box>
            </Grid>
            <TextArea texts={userListStr} name={"user list"} disabled={disables.others} id={"userlog"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => (setUserListStr(e.target.value))}/>
            <ButtonG name="get users" callback={getUserListStr} disabled={disables.others} />
        </div>
    );
}
